import React from 'react';
import {useField} from 'formik';

import ButtonGroupRadios from 'shared/portfolio/components/courses/button-group-radios';

interface Props {
  closePopover: () => void;
}

const options = [
  {value: 'P', display: <span>Pass</span>},
  {value: 'F', display: <span>Fail</span>},
];

const PFGradePicker = ({closePopover}: Props) => {
  const [, , gradeTypeHelpers] = useField('grade.gradeType');

  return (
    <div className="course-pf-grade-picker">
      <ButtonGroupRadios
        options={options}
        name="gradeInputPicker"
        onChange={() => {
          gradeTypeHelpers.setValue('P');
          closePopover();
        }}
      />
    </div>
  );
};

export default PFGradePicker;
